import { Agenzia } from './agenzia';
import { Model } from './model';
import { User } from './user';

export class PreferenzaAgenzia extends Model {
  static apiUrl: string = 'preferenze_agenzie';

  agenzia?: Agenzia;
  agenzia_id?: number;

  incaricato?: User;
  incaricato_id?: number;

  deserialize(input: any): PreferenzaAgenzia {
    let retV: PreferenzaAgenzia = new PreferenzaAgenzia();

    retV = super.deserialize(input) as PreferenzaAgenzia;

    if (input?.agenzia) {
      retV.agenzia = new Agenzia().deserialize(input.agenzia);
    }

    if (input?.incaricato) {
      retV.incaricato = new User().deserialize(input.incaricato);
    }

    return retV;
  }

  public getHumanIdentifier() {
    const agenzia = this.agenzia?.humanIdentifier || '';
    const incaricato = this.incaricato?.humanIdentifier || '';
    return [agenzia, incaricato].filter(Boolean).join(' - ') || `${this.id}`;
  }
}
